import React from 'react';
import { ModalName } from 'structure/staking/types';
import { useTranslation } from 'react-i18next';
import { StakingPoolTableRow } from './StakingPoolTableRow';
import { StakingPool, StakingProject } from 'api/StakingAPI';

type StakingPoolListProps = {
  pools: StakingPool[];
  project?: StakingProject;
  onOpenModal?: (modalName: ModalName, poolId: number) => void;
  enableExplore?: boolean;
};

export function StakingPoolTable({
  pools,
  onOpenModal,
  enableExplore,
  project,
}: StakingPoolListProps) {
  const { t } = useTranslation('common');

  const columns = [
    'TABLE_HEADER_POOL',
    'STAKING.TABLE_TOKENS_TVL',
    'STAKING.TABLE_CELL_AVG_APR',
    'STAKING.STAKED',
    'CLAIMABLE',
    'STAKING.TABLE_CELL_MY_APR',
    'STAKING.REP_SCORE',
    'STAKING.NEXT_UNLOCK',
    '',
  ];

  return (
    <div className='mx-auto w-full overflow-x-scroll !font-[Montserrat]'>
      <table className='min-w-full table-auto border-separate border-spacing-x-0 border-spacing-y-3 rounded-xl'>
        <thead>
          <tr>
            {columns.map((column, index) => (
              <th
                key={index}
                className='px-4 py-2 text-center text-xs font-normal text-[#C1CAD6]'
              >
                {t(column)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {pools.map((pool) => (
            <StakingPoolTableRow
              key={pool.id}
              pool={pool}
              project={project}
              onOpenModal={onOpenModal}
              enableExplore={enableExplore}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
